import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../utils/env';
import { IMovieItem, IMovieListResponse } from './supportMovie.types';

const movieUrl = `${EnvWindow.REACT_APP_SUPPORT_MOVIE_API_URL}/Movie`;

export async function getMoviesList(): Promise<AxiosResponse<IMovieListResponse>> {
  return await axios.get(`${movieUrl}`);
}

export async function getMovie(movieId: string): Promise<AxiosResponse<IMovieItem>> {
  return await axios.get(`${movieUrl}/${movieId}`);
}

export async function createMovie(title: string, description: string, url: string): Promise<AxiosResponse> {
  return await axios.post(movieUrl, {
    title: title,
    description: description,
    url: url,
  });
}

export async function updateMovie(
  newTitle: string,
  newDescription: string,
  newUrl: string,
  id: string,
): Promise<AxiosResponse> {
  return await axios.put(movieUrl, {
    id: id,
    title: newTitle,
    description: newDescription,
    url: newUrl,
  });
}

export async function updateMovieLike(movieId: string): Promise<AxiosResponse> {
  return await axios.put(`${movieUrl}/${movieId}`);
}

export const deleteMovie = async (movieId: string): Promise<AxiosResponse<boolean>> => {
  return await axios.delete(`${movieUrl}/${movieId}`);
};
